module.exports = __webpack_public_path__ + "img/pluto165.8c1df1cf.jpg";